module.exports = __webpack_public_path__ + "img/icon_fence.92a88a6e.png";